<template>
  <div class="car-sections" v-if="teamsiteConfig.car_sections">
    
    <div :class="`tabs-row sticky ${pageOnTop ? 'pageOnTop' : ''}`">
      <car-section-selection :sections="teamsiteConfig.car_sections" v-model="selectedCarSectionIndex">
      </car-section-selection>
    </div>
    
    
    <div class="tabs-row">
      <div class="row">
        <h3 class="column" v-if="teamsiteConfig.car_sections.length > 1">{{ $t('cars.choose_tariff') }}</h3>
        <h3 class="column" v-else>{{ teamsiteConfig.car_sections[0].name }}</h3>
      </div>
      <car-section-selection :sections="teamsiteConfig.car_sections" v-model="selectedCarSectionIndex">
      </car-section-selection>
    </div>
    
    
    <benefits v-if="selectedCarSection" :pricing="selectedCarSection" :benefits="selectedCarSection.description"></benefits>
    <car-list v-if="selectedCarSection" :selectedCarSection="selectedCarSection" :cars="selectedCarSection.cars"></car-list>
  
  </div>
</template>

<script>
import {ViewportDetectionMixin} from '@/components/ViewportDetection'
export default {

  name: 'CarSections',

  mixins: [ViewportDetectionMixin],

  data() {
    return {
      selectedCarSectionIndex: 0,
      pageOnTop: false
    }
  },

  computed: {
    selectedCarSection () {
      if (!this.teamsiteConfig.car_sections) { return }
      return this.teamsiteConfig.car_sections[this.selectedCarSectionIndex]
    }
  },

  watch: {
    selectedCarSectionIndex() {
      if (window.pageYOffset >= 140) {
        if (this.viewport == 'small' || this.viewport == 'medium') {
          window.scrollTo(0, 90)
        } else {
          window.scrollTo(0, 140)
        }
      }
    },

    selectedCarSection: {
      immediate: true,
      handler() {
        this.$bus.$emit('set:team-for-signup', this.selectedCarSection.team_id)
        this.$bus.$emit('set:team-cars', this.selectedCarSection.cars)
      }
    }
  },

  methods: {
    handleScroll () {
      this.pageOnTop = window.pageYOffset >= 140
    }
  },

  beforeDestroy () {
    this.$bus.$emit('set:team-for-signup', null)
    window.removeEventListener('scroll', this.handleScroll)
  },

  mounted () {
    window.addEventListener('scroll', _.throttle(this.handleScroll, 100))
    setTimeout(this.handleScroll, 200)
  }

}
</script>



<style lang="scss">

.car-sections {

  .tabs-row {
    width: 100%;
    background-color: #363636;
    h3 {
      margin-top: rem-calc(25);
      margin-bottom: rem-calc(20);
      color: white;
      font-size: rem-calc(25);
      text-align: center;
    }
    .mq-tab {
      height: 60px;
      .wrapper {
        font-size: rem-calc(18);
      }
      @include breakpoint(medium down) {
        height: 50px;
      }
    }
    .tab-wrapper {
      margin: 30px;
      margin-top: 10px;
      text-align: center;

      &.inactive {
        color: white;
      }
    }

    &.sticky {
      z-index: 5;
      position: fixed;
      width: 100%;
      margin-top: -250px;
      transition: margin-top .3s ease-out;
      .tab-wrapper {
        margin: 10px 30px;
        margin-bottom: 15px;
      }
      .mq-tab {
        height: 50px;
      }
      &.pageOnTop {
        margin-top: -50px;
        @include breakpoint(medium down) {
          margin-top: -15px;
        }
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/CarSections.vue